/**
 * @module  Experience/Shared-Browse
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

// Core
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { LoggerService } from '@core/logger/services/logger.service';

// Constants
import { SHARED_BROWSE_COMPONENTS } from '@experience/shop/shared-browse/constants/shared-browse.constants';
// Interfaces
import {
  UpdatedServiceDetails,
  BladeEntries,
} from '@experience/shop/shared-browse/interfaces/service-blade.interface';

@Injectable()
export class ServicesBladeService {
  /**
   * Observable declarations and definitions used for page loading and selection array
   */
  public serviceLoading$: Observable<UpdatedServiceDetails>;
  /**
   * Stores the data for the service updated
   */
  public serviceUpdated: UpdatedServiceDetails;
  /**
   * Stores the subject for checking the service loading source
   */
  private serviceLoadingSource: Subject<UpdatedServiceDetails>;
  /**
   * Instantiate subject for loading and cast is as an observable
   */
  constructor(private logger: LoggerService) {
    this.serviceLoadingSource = new Subject();
    this.serviceLoading$ = this.serviceLoadingSource.asObservable();
    this.serviceUpdated = {
      serviceId: '',
      status: '',
      isFutureDated: false,
      isServiceRemoved: false,
      isServiceAdded: false,
      isThirdPartyService: false,
    };
  }

  /**
   * Informs service loading from child to be returned to parent
   * @param serviceLoading boolean
   * @returns void
   */
  public announceServiceUpdated(
    serviceData: BladeEntries,
    isRemoved: boolean,
    isAdded: boolean
  ): void {
    this.logger.debug(
      SHARED_BROWSE_COMPONENTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.SERVICE_BLADE_SERVICE,
      'entering announceServiceUpdated() in ' + SHARED_BROWSE_COMPONENTS.SERVICE_BLADE_SERVICE
    );
    this.serviceUpdated.serviceId = serviceData.id;
    this.serviceUpdated.status = isRemoved ? 'Removed' : 'Added';
    this.serviceUpdated.isFutureDated = serviceData.isFutureDated;
    this.serviceUpdated.isServiceRemoved = isRemoved;
    this.serviceUpdated.isServiceAdded = isAdded;
    this.serviceUpdated.isThirdPartyService = serviceData.billableThirdPartyServiceIndicator;
    this.serviceLoadingSource.next(this.serviceUpdated);
    this.logger.debug(
      SHARED_BROWSE_COMPONENTS.SHARED_BROWSE_MODULE,
      SHARED_BROWSE_COMPONENTS.SERVICE_BLADE_SERVICE,
      'leaving announceServiceUpdated() in ' + SHARED_BROWSE_COMPONENTS.SERVICE_BLADE_SERVICE
    );
  }
}
